import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateNotesSmartScheduleShift", function updateNotesSmartScheduleShift(notes: string) {
    if (shiftEditorViewState().smartScheduleShift) {
        shiftEditorViewState().smartScheduleShift.notes = notes;
    }
});